import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';

export function useRequireAuth() {
  const { status } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (status === 'signed-out') navigate('/', { replace: true });
  }, [status, navigate]);
  return { ready: status === 'signed-in' };
}
